import './App.css'
import Form from './FormCalculator'

const App = () => {
  return <Form />
}

export default App
